var collapsible_list_component_rtlignore_default = {
  "ltr": "Jfg7z",
  "rtl": "zNwwh",
  "iconContainer": "ZPNmr",
  "icon": "IfHXM",
  "isExpanded": "N9-by",
  "listDimensions": "BNlGy"
};
export {
  collapsible_list_component_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-component.rtlignore-scss.js.map
